export default __webpack_public_path__ + "static/media/nelore.a66dd985.png";